export default {
  title: "Search companies",
  name: {
    label: "Name",
    placeholder: "Search on company name"
  }
}
